import { render, staticRenderFns } from "./InvitationLink.vue?vue&type=template&id=a23069b8"
import script from "./InvitationLink.vue?vue&type=script&lang=js"
export * from "./InvitationLink.vue?vue&type=script&lang=js"
import style0 from "./InvitationLink.vue?vue&type=style&index=0&id=a23069b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports